/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
  id: null,
  avatar: null,
  firstName: null,
  email: null,
  role: null
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js